import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { QuoteSummaryModel } from '@amfam/shared/models';

import { VehicleFeatures } from '../../enums';

@Component({
  selector: 'amfam-payment-schedule',
  templateUrl: './payment-schedule.component.html',
  styleUrls: ['./payment-schedule.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PaymentScheduleComponent {
  @Input() payments: QuoteSummaryModel[];
  @Input() feature: VehicleFeatures;
  features = VehicleFeatures;
}
